import sliceText from 'components/helpers/sliceText';
import DOMPurify from 'dompurify';

const CardDescription = ({ description, expand }) => {
  return (
    <div className="card__description">
      {expand ? (
        <>
          <h3>Descrição:</h3>
          {/* Dangerouslyset is necessarily because api send it as Html format*/}
          {description?.length > 800 ? (
            <p dangerouslySetInnerHTML={{ __html: sliceText(DOMPurify.sanitize(description), 0, 800) + '...' }}></p>
          ) : (
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}></p>
          )}
        </>
      ) : (
        <>
          {description?.length > 180 ? (
            <p dangerouslySetInnerHTML={{ __html: sliceText(DOMPurify.sanitize(description), 0, 180) + '...' }}></p>
          ) : (
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}></p>
          )}
        </>
      )}
    </div>
  );
};

export default CardDescription;
